<template>
  <v-card cols="12" sm="12">
    <v-card-title>
      <v-icon class="mr-2">mdi-download</v-icon>Cookie Policy
      <v-spacer></v-spacer>
      <v-btn v-if="forceShow" icon @click="$emit('close-dialog')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text
      >We only use necessary cookies to make our site work. We do not use
      Analytic cookies. Necessary cookies enable core functionality such as
      security, network management, and accessibility.</v-card-text
    >

    <v-card-title v-if="getSurveyData.hear_no == null && show_hearabout">
      <v-icon class="mr-2">hearing</v-icon>Hear About
    </v-card-title>
    <v-card-subtitle v-if="getSurveyData.hear_no == null && show_hearabout"
      >Please let us know how you heard about us.</v-card-subtitle
    >
    <v-card-text v-if="getSurveyData.hear_no == null && show_hearabout">
      <v-radio-group v-model="hear_no">
        <v-radio
          v-for="(hear_item, index) in hear_about"
          :key="index"
          :label="hear_item.hear_desc"
          :value="hear_item.hear_no"
          color="blue darken-2"
        ></v-radio>
      </v-radio-group>
    </v-card-text>

    <v-card-title v-if="show_marketing">
      <v-icon class="mr-2">mdi-message-text</v-icon>Marketing Communications
    </v-card-title>
    <v-card-text v-if="show_marketing">
      <v-checkbox
        v-model="contact_email"
        :false-value="0"
        :true-value="1"
        label="Allow Contact By Email"
        color="blue darken-2"
      ></v-checkbox>
      <v-checkbox
        v-model="contact_sms"
        :false-value="0"
        :true-value="1"
        label="Allow Contact By SMS"
        color="blue darken-2"
      ></v-checkbox>
      <v-checkbox
        v-model="contact_tel"
        :false-value="0"
        :true-value="1"
        label="Allow Contact By Telephone"
        color="blue darken-2"
      ></v-checkbox>
      <v-checkbox
        v-model="contact_post"
        :false-value="0"
        :true-value="1"
        label="Allow Contact By Post"
        color="blue darken-2"
      ></v-checkbox>
    </v-card-text>
    <v-card-actions class="dialogActions">
      <v-btn v-if="forceShow" text @click="$emit('close-dialog')">Close</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        outlined
        :loading="loadingSurvey"
        @click="putSurvey()"
        >Submit</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  props: ["getSurveyData", "forceShow"],
  data: () => ({
    show_hearabout: true,
    show_marketing: true,

    contact_email: 1,
    contact_sms: 1,
    contact_tel: 1,
    contact_post: 1,
    loadingSurvey: false,
    hear_no: null,
    hear_about: [],
  }),
  watch: {
    getSurveyData: function () {
      console.log("Survey Data Loaded");
      console.log(this.getSurveyData);

      if (this.getSurveyData.success == true) {
        if (this.getSurveyData.cookies_accept == null || this.forceShow) {
          if (this.getSurveyData.contact_email != null) {
            this.contact_email = parseInt(this.getSurveyData.contact_email);
          }

          if (this.getSurveyData.contact_sms != null) {
            this.contact_sms = parseInt(this.getSurveyData.contact_sms);
          }

          if (this.getSurveyData.contact_tel != null) {
            this.contact_tel = parseInt(this.getSurveyData.contact_tel);
          }

          if (this.getSurveyData.contact_post != null) {
            this.contact_post = parseInt(this.getSurveyData.contact_post);
          }

          this.hear_no = this.getSurveyData.hear_no;
          this.hear_about = this.getSurveyData.hear_about;
        }
      }
    },
  },

  mounted() {
    console.log("-- Some Activation");

    console.log("Survey Data Loaded");
    console.log(this.getSurveyData);

    if (this.getSurveyData.success == true) {
      if (
        (this.$store.getters.retrieveAnon &&
          this.getSurveyData.cookies_accept == null) ||
        this.forceShow
      ) {
        this.show_marketing = false;
        this.show_hearabout = false;

        this.contact_email = 0;
        this.contact_sms = 0;
        this.contact_tel = 0;
        this.contact_post = 0;

        this.hear_no = this.getSurveyData.hear_no;
        this.hear_about = this.getSurveyData.hear_about;
      } else {
        this.show_marketing = true;
        this.show_hearabout = false;

        if (this.getSurveyData.cookies_accept == null || this.forceShow) {
          if (this.getSurveyData.contact_email != null) {
            this.contact_email = parseInt(this.getSurveyData.contact_email);
          }

          if (this.getSurveyData.contact_sms != null) {
            this.contact_sms = parseInt(this.getSurveyData.contact_sms);
          }

          if (this.getSurveyData.contact_tel != null) {
            this.contact_tel = parseInt(this.getSurveyData.contact_tel);
          }

          if (this.getSurveyData.contact_post != null) {
            this.contact_post = parseInt(this.getSurveyData.contact_post);
          }

          this.hear_no = this.getSurveyData.hear_no;
          this.hear_about = this.getSurveyData.hear_about;
        }
      }
    }
  },

  // mounted() {
  //   console.log("Survey Data Loaded");
  //   console.log(this.getSurveyData);

  //   if (this.getSurveyData.success == true) {
  //     if (this.getSurveyData.cookies_accept == null || this.forceShow) {
  //       if (this.getSurveyData.contact_email != null) {
  //         this.contact_email = parseInt(this.getSurveyData.contact_email);
  //       }

  //       if (this.getSurveyData.contact_sms != null) {
  //         this.contact_sms = parseInt(this.getSurveyData.contact_sms);
  //       }

  //       if (this.getSurveyData.contact_tel != null) {
  //         this.contact_tel = parseInt(this.getSurveyData.contact_tel);
  //       }

  //       if (this.getSurveyData.contact_post != null) {
  //         this.contact_post = parseInt(this.getSurveyData.contact_post);
  //       }

  //       this.hear_no = this.getSurveyData.hear_no;
  //       this.hear_about = this.getSurveyData.hear_about;
  //     }
  //   }
  // },

  methods: {
    async putSurvey() {
      console.log(" -- Put Survey");
      this.loadingSurvey = true;

      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        cookies_accept: 1,
        contact_email: this.contact_email,
        contact_sms: this.contact_sms,
        contact_tel: this.contact_tel,
        contact_post: this.contact_post,
        hear_no: this.hear_no,
      });
      const params = new URLSearchParams();
      params.append("params", stringPayload);

      console.log(stringPayload);

      await axios
        .post("put-survey", params)
        .then((response) => {
          if (response.data.success == true) {
            return response.data.success;
          } else {
            return response.data.success;
          }
        })
        .catch((e) => {
          console.log(e);
          return false;
        });

      this.loadingSurvey = false;

      this.$emit("close-dialog");
    },
  },
};
</script>